import { Lodash } from '@intelipost-js/secure-providers';

export default {
  setRealtimeStatus(state, status) {
    state.realtimeStatus = status;
  },
  toggleLoading(state, loading) {
    state.loading = loading;
  },
  setquoteFreight(state, quoteFreight) {
    state.quoteFreight = quoteFreight;
  },
  setquoteFreightVolume(state, quoteFreightVolume) {
    state.quoteFreightVolume = quoteFreightVolume;
  },
  setquoteFreightProduct(state, quoteFreightProduct) {
    state.quoteFreightProduct = quoteFreightProduct;
  },
  setContractMode(state, logistic_contract_mode) {
    state.logistic_contract_mode = logistic_contract_mode;
  },
  setShipmentTypeMode(state, shipment_type) {
    state.shipment_type = shipment_type;
  },
  setDeliveryMethodList(state, delivery_method_list) {
    state.delivery_method_list = delivery_method_list;
  },
  setSkipQuoteRulesMode(state, skip_quote_rules) {
    state.skip_quote_rules = skip_quote_rules;
  },
  setContractList(state, data) {
    const {
      delivery_method_id,
      delivery_method,
      delivery_method_name,
    } = data;
    state.contract_list.push({
      ...delivery_method,
      name: delivery_method_name,
      id: delivery_method_id,
    });
  },
  resetContractList(state) {
    state.contract_list = [];
  },
  setOriginZipCode(state, zip_code) {
    state.quoteFreightVolume.origin_zip_code = zip_code;
    state.quoteFreightProduct.origin_zip_code = zip_code;
    state.quoteFreightComparison.origin_zip_code = zip_code;
  },
  deleteContract(state, { contract }) {
    const newArray = state.contract_list.filter(c => contract.id !== c.id);
    state.contract_list = newArray;
  },
  deleteContractId(state, { contract }) {
    const { id: contract_id } = contract;
    const object = state.contract_select_object_ids;
    state.contract_select_object_ids = Lodash.omit(object, contract_id);
  },
  cleanUpdateContractId(state) {
    state.contract_select_object_ids = {};
  },
  setUpdateContractId(state, { contract_id, list }) {
    const object = state.contract_select_object_ids;
    object[contract_id] = list;
    state.contract_select_object_ids = object;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-quote/features/freight-quote/store/mutations.js